var _g, _path, _path2, _path3, _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 235,
    viewBox: "0 0 337 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224 -5.17558e-05L8 -6.10352e-05L8 15.9999L224 15.9999C263.764 15.9999 296 48.2355 296 88L296 211L312 211L312 88C312 39.3989 272.601 -4.96679e-05 224 -5.17558e-05Z",
    fill: "url(#paint0_linear_62_959)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.343 202.657L284.657 191.343L305 211.686L325.343 191.343L336.657 202.657L305 234.314L273.343 202.657Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227 92C231.418 92 235 95.5817 235 100C235 104.418 231.418 108 227 108C222.582 108 219 104.418 219 100C219 95.5817 222.582 92 227 92ZM227 76C240.255 76 251 86.7452 251 100C251 113.255 240.255 124 227 124C213.745 124 203 113.255 203 100C203 86.7452 213.745 76 227 76Z",
    fill: "#4DE295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.96565 108L162.969 108L162.771 92.001L-2.16357 92.001L-1.96565 108Z",
    fill: "url(#paint1_linear_62_959)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.96624 205L86.5827 205L86.3848 189.001L-2.16417 189.001L-1.96624 205Z",
    fill: "url(#paint2_linear_62_959)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 13.3834,
    height: 54.2374,
    transform: "matrix(-0.709841 -0.704362 0.709841 -0.704362 137.5 220.378)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13.3834,
    height: 54.2374,
    transform: "matrix(-0.709841 0.704362 0.709841 0.704362 137.5 173.371)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_959",
    x1: 205.5,
    y1: 44.3964,
    x2: 17.0252,
    y2: 3.15296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_959",
    x1: 63.898,
    y1: 100.862,
    x2: 167.726,
    y2: 99.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_959",
    x1: 33.3532,
    y1: 197.862,
    x2: 89.0966,
    y2: 197.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2E40",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.27eeed7bd49d062680632790d7648f06.svg";
export { ForwardRef as ReactComponent };